import { type ReactNode } from 'react';
import { css, type Theme } from '@emotion/react';
import { Typography } from 'client/components/Typography';
import { ImportedEnvironmentInput } from 'client/sections/environment/ImportedEnvironmentInput';

export interface ImportedEnvironmentProps {
  stackComponentID: number;
  values: {
    stackComponentID: number;
    identifier: string;
    value: string | number | boolean | null;
  }[];
  label?: string | JSX.Element;
  children?: ReactNode;
}

export const ImportedEnvironment = ({ stackComponentID, values, label, children }: ImportedEnvironmentProps) => {
  return (
    <div>
      {label && (
        <Typography component="label" css={labelStyle}>
          {label}
        </Typography>
      )}
      <div css={listStyle}>
        {values.map((env, index) => (
          <ImportedEnvironmentInput key={`${index}-${env.identifier}`} parentStackComponentID={stackComponentID} {...env} />
        ))}
      </div>

      {children}
    </div>
  );
};

const listStyle = css`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const labelStyle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  font-weight: 700 !important;
  font-size: 16px;
  transform-origin: 0 50%;
  transform: translateX(0) scale(0.75);

  > svg,
  > figure {
    transform: translateY(1px);
  }

  > span {
    color: ${theme.color.red[100]};
    opacity: 0.8;

    svg {
      transform: translateY(3px);
    }
  }
`;
